import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from '@awaze/design-system.components.text';
import { formatISO } from 'date-fns';
import { PriceWrapper, StyledDayContainer } from './calendar-day.styles';
import { StyledDayBox, StyledDayContent } from './calendar-month.styles';
import { getDateKey, isSameDate } from './calendar.utils';
export const CalendarDay = ({ date, isActive, isUnselectable, minDate, maxDate, onDayClick = () => null, availability, isStartOfActiveRange, isEndOfActiveRange, onDayHover, isHovered, isStartOfHoveredRange, isEndOfHoveredRange, largeAmounts, formatPrice, }) => {
    const availabilityProvided = availability
        ? Object.keys(availability).length !== 0
        : false;
    const dateNotAvailable = () => {
        const formattedDate = formatISO(date, { representation: 'date' });
        if (availabilityProvided && availability[formattedDate]) {
            return false;
        }
        return true;
    };
    const currentDay = date.getDate();
    const isOutOfRange = date < minDate ||
        date > maxDate ||
        (availabilityProvided && dateNotAvailable()) ||
        isUnselectable;
    const dateKey = getDateKey(date);
    const price = availability && availability[dateKey]?.price;
    const isToday = isSameDate(new Date(), date);
    const cellContent = (_jsxs(_Fragment, { children: [_jsx(Text, { sizes: 300, type: "mid", children: currentDay }), availability && (_jsx(PriceWrapper, { children: price && _jsx(Text, { sizes: 100, children: formatPrice(price) }) }))] }));
    return (_jsx(StyledDayBox, { largeAmounts: largeAmounts, children: _jsx(StyledDayContent, { children: _jsx(StyledDayContainer, { isToday: isToday, isActive: isActive, isStartOfActiveRange: isStartOfActiveRange, ...(!isOutOfRange && {
                    autoFocus: isStartOfActiveRange,
                }), isEndOfActiveRange: isEndOfActiveRange, isBookable: Boolean(price), isUnselectable: isUnselectable, isOutOfRange: isOutOfRange && !isUnselectable, as: isOutOfRange ? 'div' : 'button', onClick: isOutOfRange ? null : () => onDayClick(date), "data-out-of-range": isOutOfRange, "data-is-active": isActive, type: isOutOfRange ? null : 'button', onMouseEnter: () => {
                    onDayHover(isOutOfRange ? null : date);
                }, onMouseLeave: () => {
                    onDayHover(null);
                }, isHovered: isHovered, isStartOfHoveredRange: isStartOfHoveredRange, isEndOfHoveredRange: isEndOfHoveredRange, largeAmounts: largeAmounts, children: cellContent }) }) }));
};
//# sourceMappingURL=calendar-day.js.map